// Country Localization v2.0 - Global Market Selection with Shopify Markets
// Shows markets from shop.metafields.custom.valid_markets, with "Global" for all others

// Prevent duplicate class declaration if script is loaded multiple times
if (typeof window.CountryLocalization === 'undefined') {

window.CountryLocalization = class CountryLocalization {
  constructor(localPosition) {
    this.countryList = document.getElementById(localPosition + 'List');
    if (!this.countryList) return;
    
    // Get visible markets from data attribute (loaded from shop.metafields.custom.valid_markets)
    const visibleMarketsData = this.countryList.dataset.visibleMarkets;
    this.visibleMarkets = visibleMarketsData ? JSON.parse(visibleMarketsData) : [];
    this.currentCountry = this.countryList.dataset.currentCountry;
    this.isVisibleMarket = this.visibleMarkets.includes(this.currentCountry);
    
    this.init();
  }
  
  init() {
    // Add click event listeners to all country items
    this.countryList.querySelectorAll('.disclosure__link').forEach(link => {
      link.addEventListener('click', (e) => this.handleCountrySelection(e));
    });
    
    // Fetch and store detected country for Global selection
    this.fetchDetectedCountry();
  }
  
  async handleCountrySelection(event) {
    event.preventDefault();
    const selectedValue = event.currentTarget.getAttribute('data-value');
    const form = event.currentTarget.closest('form');
    const input = form.querySelector('input[name="country_code"]');
    
    // Remove active class from all links
    this.countryList.querySelectorAll('.disclosure__link').forEach(link => {
      link.classList.remove('disclosure__link--active');
      link.removeAttribute('aria-current');
    });
    
    // Add active class to selected link
    event.currentTarget.classList.add('disclosure__link--active');
    event.currentTarget.setAttribute('aria-current', 'true');
    
    // Handle Global selection
    if (selectedValue === 'GLOBAL') {
      await this.handleGlobalSelection(input, form);
      return;
    }
    
    // For visible market countries (US/UK), submit the form normally
    input.value = selectedValue;
    form.submit();
  }
  
  async handleGlobalSelection(input, form) {
    console.log('[Global Selection] Switching to Global market');
    
    // Get the user's detected country to submit with
    let globalCountry = sessionStorage.getItem('detectedCountryCode');
    
    // If we don't have a detected country yet, fetch it
    if (!globalCountry) {
      try {
        const response = await fetch(
          window.Shopify.routes.root + 'browsing_context_suggestions.json'
        );
        const data = await response.json();
        
        if (data.detected_values?.country?.handle) {
          globalCountry = data.detected_values.country.handle.toUpperCase();
          sessionStorage.setItem('detectedCountryCode', globalCountry);
        }
      } catch (error) {
        console.error('[Global Selection] Error fetching detected country:', error);
      }
    }
    
    // Default to CA if we couldn't detect, or if detected is a visible market
    if (!globalCountry || this.visibleMarkets.includes(globalCountry)) {
      globalCountry = 'CA'; // Default to Canada for Global market
    }
    
    console.log('[Global Selection] Submitting with country:', globalCountry);
    
    // Submit the form with the global market country
    input.value = globalCountry;
    form.submit();
  }
  
  async fetchDetectedCountry() {
    // Fetch and store the user's detected country for use with Global selection
    try {
      const response = await fetch(
        window.Shopify.routes.root + 'browsing_context_suggestions.json'
      );
      const data = await response.json();
      
      if (data.detected_values?.country?.handle) {
        const detectedCountry = data.detected_values.country.handle.toUpperCase();
        sessionStorage.setItem('detectedCountryCode', detectedCountry);
      }
    } catch (error) {
      console.error('[Country Detection] Error:', error);
    }
  }
};

} // End of CountryLocalization class definition guard

// Initialize when DOM is ready (only once)
if (!window.countryLocalizationInitialized) {
  window.countryLocalizationInitialized = true;
  
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCountryLocalizations);
  } else {
    initCountryLocalizations();
  }
}

function initCountryLocalizations() {
  // Prevent multiple initializations
  if (window.countryLocalizationReady) return;
  window.countryLocalizationReady = true;
  
  // Find all country localization lists and initialize them
  document.querySelectorAll('[id$="List"]').forEach(list => {
    if (list.id.includes('CountryList') || list.classList.contains('disclosure__list')) {
      const localPosition = list.id.replace('List', '');
      new window.CountryLocalization(localPosition);
    }
  });
}

